import { render, staticRenderFns } from "./AllocateDialog.vue?vue&type=template&id=521a7422&scoped=true"
import script from "./AllocateDialog.vue?vue&type=script&lang=js"
export * from "./AllocateDialog.vue?vue&type=script&lang=js"
import style0 from "./AllocateDialog.vue?vue&type=style&index=0&id=521a7422&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a7422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521a7422')) {
      api.createRecord('521a7422', component.options)
    } else {
      api.reload('521a7422', component.options)
    }
    module.hot.accept("./AllocateDialog.vue?vue&type=template&id=521a7422&scoped=true", function () {
      api.rerender('521a7422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/terminal/AllocateDialog.vue"
export default component.exports